<template>
  <nav class="navbar navbar-expand-lg navigation-bar">
    <div class="container-fluid nav-container">
      <!-- Brand -->
      <a
        class="navbar-brand brand-section"
        @click="scrollToSection('home')"
        style="cursor: pointer"
      >
        <img
          src="@/assets/images/ahrs-logo-horizontal.png"
          alt="Africa Human Resource Summit"
          class="brand-logo"
        />
      </a>

      <!-- Bootstrap toggler -->
      <button
        class="navbar-toggler"
        type="button"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Menu -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto align-items-lg-center">
          <li class="nav-item">
            <a
              class="nav-link"
              @click="scrollToSection('home')"
              style="cursor: pointer"
              >HOME</a
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/speakers" @click="closeNavbar"
              >SPEAKERS</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/agenda" @click="closeNavbar"
              >AGENDA</router-link
            >
          </li>

          <!-- Partnership Dropdown -->
          <li
            class="nav-item dropdown"
            :class="{ show: openDropdown === 'partnership' }"
          >
            <a
              class="nav-link dropdown-toggle"
              href="javascript:void(0)"
              id="partnershipDropdown"
              role="button"
              :aria-expanded="openDropdown === 'partnership' ? 'true' : 'false'"
              @click.stop="toggleDropdown('partnership')"
            >
              PARTNERSHIP
            </a>
            <ul
              class="dropdown-menu"
              :class="{ show: openDropdown === 'partnership' }"
              aria-labelledby="partnershipDropdown"
            >
              <li>
                <router-link
                  class="dropdown-item"
                  to="/sponsorship"
                  @click="onDropdownItemClick"
                  >SPONSORSHIP</router-link
                >
              </li>
              <li>
                <router-link
                  class="dropdown-item"
                  to="/partners"
                  @click="onDropdownItemClick"
                  >PARTNERS</router-link
                >
              </li>
            </ul>
          </li>

          <!-- Journey Dropdown -->
          <li
            class="nav-item dropdown"
            :class="{ show: openDropdown === 'journey' }"
          >
            <a
              class="nav-link dropdown-toggle"
              href="javascript:void(0)"
              id="journeyDropdown"
              role="button"
              :aria-expanded="openDropdown === 'journey' ? 'true' : 'false'"
              @click.stop="toggleDropdown('journey')"
            >
              JOURNEY
            </a>
            <ul
              class="dropdown-menu"
              :class="{ show: openDropdown === 'journey' }"
              aria-labelledby="journeyDropdown"
            >
              <li>
                <router-link
                  to="/tour"
                  class="dropdown-item"
                  @click="onDropdownItemClick"
                  >TOUR</router-link
                >
              </li>
              <li>
                <router-link
                  to="/accommodation"
                  class="dropdown-item"
                  @click="onDropdownItemClick"
                  >ACCOMODATION</router-link
                >
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link class="nav-link" to="/contact" @click="closeNavbar"
              >CONTACT</router-link
            >
          </li>

          <!-- CTA -->
          <li class="nav-item nav-cta">
            <button class="btn btn-register" @click="handleRegister">
              Register Now
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap";

export default {
  name: "NavigationBar",
  data() {
    return {
      openDropdown: null, // 'partnership' | 'journey' | null
    };
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    toggleNavbar() {
      const navbarCollapse = document.getElementById("navbarNav");
      if (!navbarCollapse) return;
      if (navbarCollapse.classList.contains("show")) {
        this.closeNavbar();
      } else {
        const bsCollapse =
          Collapse.getInstance(navbarCollapse) || new Collapse(navbarCollapse);
        bsCollapse.show();
      }
    },
    closeNavbar() {
      this.openDropdown = null;
      const navbarCollapse = document.getElementById("navbarNav");
      if (navbarCollapse && navbarCollapse.classList.contains("show")) {
        const bsCollapse =
          Collapse.getInstance(navbarCollapse) ||
          new Collapse(navbarCollapse, { toggle: false });
        bsCollapse.hide();
      }
    },
    toggleDropdown(name) {
      this.openDropdown = this.openDropdown === name ? null : name;
    },
    onDropdownItemClick() {
      this.openDropdown = null;
      this.closeNavbar();
    },
    handleOutsideClick(event) {
      if (!this.openDropdown) return;
      if (!event.target.closest(".nav-item.dropdown")) {
        this.openDropdown = null;
      }
    },
    handleRegister() {
      this.closeNavbar();
      this.$router.push("/registration");
    },
    scrollToSection(sectionId) {
      this.closeNavbar();

      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" }).then(() => {
          setTimeout(() => {
            this.smoothScrollToElement(sectionId);
          }, 100);
        });
        return;
      }

      if (sectionId === "home") {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      this.smoothScrollToElement(sectionId);
    },
    smoothScrollToElement(sectionId) {
      setTimeout(() => {
        const element = document.querySelector(`.${sectionId}-section`);
        if (element) {
          const offsetTop = element.offsetTop - 100;
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }
      }, 100);
    },
  },
};
</script>

<style scoped>
.navigation-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(230, 241, 232, 0.92) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(17, 149, 73, 0.18);
  box-shadow: 0 4px 18px rgba(17, 149, 73, 0.08);
  padding: 0.6rem 0;
  transition: background 0.3s ease;
}

.nav-container {
  padding: 0 3rem !important;
  position: relative;
}

/* Brand */
.brand-section {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.brand-logo {
  height: 52px;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.brand-logo:hover {
  transform: scale(1.04);
}

/* Nav links */
.navbar-nav {
  gap: 1.5rem;
}

.nav-link {
  color: #10271b !important;
  text-decoration: none;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.06em;
  padding: 0.5rem 0.75rem !important;
  transition: color 0.25s ease;
  position: relative;
  display: inline-block;
}

.nav-link:hover,
.nav-link:focus {
  color: #0c6e37 !important;
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: 2px;
  left: 0.75rem;
  right: 0.75rem;
  height: 2px;
  background: #119549;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease;
}

.nav-link:hover::after {
  transform: scaleX(1);
}

/* Dropdown */
.dropdown-toggle::after {
  display: inline-block !important;
  margin-left: 0.4rem;
  vertical-align: 0.15em;
  content: "" !important;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
  transition: transform 0.3s ease;
  color: #10271b !important;
}

.dropdown.show .dropdown-toggle::after {
  transform: rotate(180deg);
}

@media (min-width: 992px) {
  .dropdown:hover .dropdown-menu {
    display: block;
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .dropdown:hover .dropdown-toggle::after {
    transform: rotate(180deg);
  }

  .dropdown-menu::before {
    content: "";
    position: absolute;
    top: -0.5rem;
    left: 0;
    right: 0;
    height: 0.5rem;
  }
}

.dropdown-menu {
  background: rgba(251, 254, 252, 0.98) !important;
  backdrop-filter: blur(14px);
  border: 1px solid rgba(17, 149, 73, 0.2) !important;
  border-radius: 10px;
  min-width: 200px;
  margin-top: 0.5rem !important;
  box-shadow: 0 12px 32px rgba(17, 149, 73, 0.12) !important;
  padding: 0.4rem 0;
}

.dropdown-item {
  color: #10271b !important;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  padding: 0.65rem 1rem !important;
  transition: all 0.25s ease;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background: rgba(17, 149, 73, 0.1) !important;
  color: #0c6e37 !important;
  padding-left: 1.2rem !important;
}

/* CTA */
.nav-cta {
  margin-left: 0.5rem;
}

.btn-register {
  background: #119549 !important;
  color: #ffffff !important;
  border: none !important;
  padding: 0.7rem 1.4rem;
  border-radius: 100px;
  font-family: "Inter", "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 22px -8px rgba(17, 149, 73, 0.6);
  white-space: nowrap;
}

.btn-register:hover {
  background: #16a85a !important;
  transform: translateY(-2px);
  box-shadow: 0 12px 30px -8px rgba(22, 168, 90, 0.7);
}

/* Toggler */
.navbar-toggler {
  border: 1px solid rgba(17, 149, 73, 0.4) !important;
  padding: 0.45rem 0.7rem;
}

.navbar-toggler:focus {
  box-shadow: 0 0 0 0.15rem rgba(17, 149, 73, 0.35) !important;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%2310271b' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

/* Responsive */
@media (max-width: 991px) {
  .nav-container {
    padding: 0 1.25rem !important;
  }

  .brand-logo {
    height: 44px;
  }

  .navbar-collapse {
    background: rgba(251, 254, 252, 0.98);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    margin-top: 0.8rem;
    padding: 1.2rem;
    border-radius: 12px;
    border: 1px solid rgba(17, 149, 73, 0.18);
    box-shadow: 0 12px 32px rgba(17, 149, 73, 0.12);
  }

  .navbar-nav {
    gap: 0.4rem;
    align-items: stretch !important;
  }

  .nav-link {
    text-align: center;
    font-size: 15px;
    padding: 0.7rem 1rem !important;
  }

  .nav-link::after {
    left: 1rem;
    right: 1rem;
  }

  .dropdown-menu {
    position: static !important;
    float: none;
    width: auto;
    background: rgba(17, 149, 73, 0.05) !important;
    border: 1px solid rgba(17, 149, 73, 0.18) !important;
    margin-top: 0.4rem !important;
    margin-left: 1rem;
    margin-right: 1rem;
    box-shadow: none !important;
    transform: none !important;
  }

  .dropdown-menu.show {
    display: block;
  }

  .dropdown-item {
    text-align: center;
    font-size: 14px;
  }

  .nav-cta {
    margin-left: 0;
    margin-top: 0.8rem;
  }

  .btn-register {
    width: 100%;
    padding: 0.8rem;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 0 0.85rem !important;
  }

  .brand-logo {
    height: 38px;
  }

  .nav-link {
    font-size: 14px;
  }
}
</style>
